//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface MenuModule {
  id: number;
  moduleCode: string;
  moduleName: string;
  moduleDisplayName: string;
  displayOrder: number;
}

interface MenuItem {
  menuHeading: string;
  menuDisplayOrder: number;
  modules: MenuModule[];
}

interface MenuState {
  items: MenuItem[];
  loading: boolean;
  error: string | null;
}

const initialState: MenuState = {
  items: [],
  loading: false,
  error: null,
};

export const fetchMenuItems = createAsyncThunk<MenuItem[], { userId: string; sectorId: string; roleId: number }>(
  'menu/fetchMenuItems',
  async ({ userId, sectorId, roleId }) => {
    try {
      const response = await axiosInstance.post<MenuItem[]>(`${BASE_URL}/api/v1/Module/GetModuleByUserIdSectorIdRoleId`, {
        roleid: roleId,
        userid: userId,
        sectorid: sectorId,
      });

      return response.data;
    } catch (error: any) {
      throw error;
    }
  }
);

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenuItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenuItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchMenuItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to load menu items';
      });
  },
});

export default menuSlice.reducer;
